module.exports = __webpack_public_path__ + "img/close-circle.737fee25.svg";